import React from 'react'
import './Commitment.css'

import TabsItem from './TabsItem'

function Commitment () {
  
  return (
    <div className="commitment-section" id='Commitment'>
        <div className="container">
            <div className="commitment-content">
                <div className="commitment-header">
                     <div className="tagline">
                        <span>OUR COMMITMENT</span>
                    </div>
                        <h2>Committed to Security, Integrity & Excellence</h2>
                </div>

                <div className="tabs-items">
                  <TabsItem/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Commitment 
